import { Bell, LogOut, User } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "./NotificationBell";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { logout } from "@/redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

export function Topbar() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.auth.user);
  const tenant = useAppSelector((s) => s.auth.tenant);

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-2 border-b bg-card/60 px-4 backdrop-blur-xl sm:px-6">
      <div className="flex items-center gap-4">
        <SidebarTrigger className="h-9 w-9 rounded-xl hover:bg-primary/5 hover:text-primary transition-colors" />
        <div className="hidden h-6 w-px bg-border/50 sm:block" />
        <p className="hidden text-xs font-black uppercase tracking-[0.2em] text-muted-foreground/60 sm:block">
          {tenant?.name || "Medicos Admin"}
        </p>
      </div>
      
      <div className="flex-1" />
      
      <div className="flex items-center gap-3">
        <NotificationBell />
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex items-center gap-2.5 rounded-xl border bg-card/50 p-1 pr-3 text-sm transition-all hover:bg-muted/50 hover:shadow-md ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground shadow-lg shadow-primary/20">
                <User className="h-4 w-4" />
              </div>
              <span className="hidden font-bold tracking-tight text-foreground sm:inline">{user?.name ?? "Admin"}</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56 rounded-2xl p-2 shadow-2xl border-none ring-1 ring-black/5">
            <DropdownMenuLabel className="px-2 py-1.5">
              <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground mb-1">Signed in as</p>
              <p className="text-sm font-bold text-foreground truncate">{user?.name || "Admin"}</p>
              <p className="text-xs font-medium text-muted-foreground truncate">{user?.email || "admin@medicos.com"}</p>
            </DropdownMenuLabel>
            <DropdownMenuSeparator className="mx-2 my-1" />
            <DropdownMenuItem
              onClick={() => {
                dispatch(logout());
                navigate("/login");
              }}
              className="rounded-xl text-destructive focus:bg-destructive/10 focus:text-destructive h-10 font-bold"
            >
              <LogOut className="mr-2 h-4 w-4" /> Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
